<template>
  <button
    :class="fullCssClass"
    title="Open Menu"
    @click="toggle"
  >
    <span class="hamburger-box">
      <span class="hamburger-inner" />
    </span>
  </button>
</template>

<script>
export default {
  name: 'MenuButton',
  props: {
    cssClass: {
      type: String,
      default: ''
    },
    hamburgerType: {
      type: String,
      default: '3dx'
    },
    initialSstate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      state: this.initialSstate
    }
  },
  computed: {
    fullCssClass() {
      return "menu-button hamburger hamburger--" + this.hamburgerType + (this.state ? " is-active" : '') + ' ' + this.cssClass
    }
  },
  methods: {
    toggle() {
      this.state = !this.state
      this.$emit('menu-toggle', this.state)
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-button {
  background: transparent;
  border-radius: 0;
  &.reverse {
    .hamburger-inner {
      background: black;
      &:before, &:after {
        background: black;
      }
    }
  }
}
</style>